import React, { Component, PropTypes } from 'react';
import { withRouter, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { setCatalog, clearCatalogsErrors } from '../actions';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import Alert from '../components/home/Alert';

// import '../assets/stylesheets/catalogs.scss';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  catalog: PropTypes.object,
  error: PropTypes.any,
  query: PropTypes.object.isRequired,
};

class CatalogNewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: !props.isAuthenticated,
      alertOpen: false,
      alertMessage: '',
      error: false,
      required: {
        name: null,
        description: null,
      },
      catalog: {
        name: '',
        description: '',
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.goBack();
    }
    this.setRequiredParams();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        error: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
    if (nextProps.catalog && !nextProps.error) {
      this.setState({
        alertOpen: true,
        error: false,
        alertMessage: 'Catalog saved successfully!',
      });
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const catalog = this.state.catalog;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = catalog[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleChange(e) {
    const nextState = this.state.catalog;
    nextState[e.target.name] = e.target.value;
    this.setState({
      catalog: nextState,
    });
    this.setRequiredParams();
  }
  handleSubmit() {
    this.props.dispatch(clearCatalogsErrors());
    this.props.dispatch(setCatalog(this.state.catalog));
  }
  handleCancel() {
    this.props.dispatch(clearCatalogsErrors());
    browserHistory.push('/catalogs?page=1');
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    if (!this.state.error) {
      browserHistory.push('/catalogs?page=1');
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
    };
    return (
      <div className="catalogs component" style={authPage}>
        <h2>New Catalog</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ margin: '20px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleSubmit}
            />
          </div>
          <br />
          <br />
          <TextField
            floatingLabelText="Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="name"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.name}
            errorStyle={{ color: cyan500 }}
          />
          <br/>
          <TextField
            floatingLabelText="Description"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="description"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.description}
            errorStyle={{ color: cyan500 }}
            multiLine={true}
          />
        </div>
      </div>
    );
  }
}

CatalogNewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

CatalogNewPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    catalog: state.catalogs.catalog,
    error: state.catalogs.error,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(CatalogNewPage));



// WEBPACK FOOTER //
// ./src/containers/CatalogNewPage.js